import $ from "jquery";
import React, { useEffect, useState } from "react";
import Mooz_Logo from '../assets/img/Mooz_Logo.png'

const NotFound = (props) => {

  return (
  	<div className="w-100 h-100 d-flex align-items-center justify-content-center">
			<div className="text-center">
				<img src={Mooz_Logo} style={{ height: '10rem', }}/>
				<h2 className="mt-3">Web is on Maintenance</h2>
				<p>Please wait while Web is developing.</p>
			</div>
  	</div>
  );
};

export default NotFound;
